// =============================================
// Personalização de Produtos — Área do Cliente
// =============================================
(function () {
  'use strict';

  var $page = $('#pers-page');
  if ($page.length === 0) return;

  // --- Configuração ---
  var siteUrl = $page.data('url');
  var apiUrl = $page.data('api');

  // --- Constantes ---
  var MAX_JOGADORES = 50;
  var LOCAL_KEY = 'laserena_selected_products';
  var LOCAL_PERS_KEY = 'laserena_personalizacao';
  var CORES_PERSONALIZACAO = $page.data('cores') || ['Preto', 'Branco', 'Dourado'];

  // --- Estado ---
  var produtos = [];
  var stepsOrder = [];
  var allCategories = [];
  var currentStepIndex = 0;
  var isRosterStep = false;
  var personalizacao = {};
  var jogadores = [];
  var logoUploads = {};

  // --- Elementos ---
  var $timeline = $('#pers-timeline');
  var $sidebar = $('#pers-sidebar');
  var $main = $('#pers-main');
  var $stepCustom = $('#pers-step-custom');
  var $stepRoster = $('#pers-step-roster');
  var $productTitle = $('#pers-product-title');
  var $previewProduct = $('#pers-preview-product');
  var $previewLogo = $('#pers-preview-logo');
  var $previewLogoImg = $('#pers-preview-logo-img');
  var $options = $('#pers-options');
  var $priceSummary = $('#pers-price-summary');
  var $productCards = $('#pers-product-cards');
  var $rosterThead = $('#pers-roster-thead');
  var $rosterTbody = $('#pers-roster-tbody');
  var $orderSummary = $('#pers-order-summary');
  var $btnPrev = $('#pers-btn-prev');
  var $btnNext = $('#pers-btn-next');
  var $bottomBar = $('#pers-bottom-bar');

  // =============================================
  // INICIALIZAÇÃO
  // =============================================
  function init() {
    var savedProducts = {};
    try {
      var raw = localStorage.getItem(LOCAL_KEY);
      if (raw) savedProducts = JSON.parse(raw);
    } catch (e) {
      /* ignore */
    }

    var ids = [];
    for (var catId in savedProducts) {
      if (savedProducts.hasOwnProperty(catId) && savedProducts[catId]) {
        ids.push(savedProducts[catId].id);
      }
    }

    if (ids.length === 0) {
      window.location.href = siteUrl + 'minha-conta/produtos';
      return;
    }

    showLoading();
    $.ajax({
      url: apiUrl,
      type: 'GET',
      data: { acao: 'dados_iniciais', ids: ids.join(',') },
      dataType: 'json',
    })
      .done(function (resp) {
        if (resp.status === 'ok' && resp.produtos && resp.produtos.length > 0) {
          produtos = resp.produtos;

          produtos.sort(function (a, b) {
            return a.categoria_ordem - b.categoria_ordem;
          });

          try {
            var savedPers = localStorage.getItem(LOCAL_PERS_KEY);
            if (savedPers) personalizacao = JSON.parse(savedPers);
          } catch (e) {
            /* ignore */
          }

          buildSteps();
          buildTimeline();
          buildSidebar();

          if (stepsOrder.length > 0) {
            navigateToStep(0);
          } else {
            showRosterStep();
          }
        } else {
          window.location.href = siteUrl + 'minha-conta/produtos';
        }
      })
      .fail(function () {
        window.location.href = siteUrl + 'minha-conta/produtos';
      });
  }

  function showLoading() {
    $main.find('.pers-step').hide();
    var loading = document.createElement('div');
    loading.className = 'pers-loading';
    loading.id = 'pers-main-loading';

    var spinner = document.createElement('div');
    spinner.className = 'pers-loading-spinner';
    loading.appendChild(spinner);

    var text = document.createElement('span');
    text.textContent = 'Carregando...';
    loading.appendChild(text);

    $main.prepend(loading);
  }

  function hideLoading() {
    $('#pers-main-loading').remove();
  }

  // =============================================
  // CONSTRUIR ETAPAS
  // =============================================
  function buildSteps() {
    allCategories = [];
    stepsOrder = [];

    for (var i = 0; i < produtos.length; i++) {
      var p = produtos[i];
      var slug = p.categoria_slug;
      var hasPersonalizacoes =
        p.personalizacoes && p.personalizacoes.length > 0;

      allCategories.push({
        slug: slug,
        titulo: p.categoria_titulo,
        hasConfig: hasPersonalizacoes,
      });

      if (hasPersonalizacoes) {
        var found = false;
        for (var j = 0; j < stepsOrder.length; j++) {
          if (stepsOrder[j] === slug) {
            found = true;
            break;
          }
        }
        if (!found) {
          stepsOrder.push(slug);
        }
      }
    }
  }

  // =============================================
  // TIMELINE
  // =============================================
  function buildTimeline() {
    $timeline.empty();

    for (var i = 0; i < stepsOrder.length; i++) {
      var slug = stepsOrder[i];
      var titulo = getCategoryTitle(slug);

      var step = document.createElement('div');
      step.className = 'pers-timeline-step' + (i === 0 ? ' active' : '');
      step.setAttribute('data-step', i);
      step.setAttribute('data-slug', slug);

      var label = document.createElement('span');
      label.className = 'pers-timeline-label';
      label.textContent = titulo;
      step.appendChild(label);

      $timeline.append(step);
    }

    var rosterStep = document.createElement('div');
    rosterStep.className = 'pers-timeline-step';
    rosterStep.setAttribute('data-step', 'roster');

    var rosterLabel = document.createElement('span');
    rosterLabel.className = 'pers-timeline-label';
    rosterLabel.textContent = 'Resumo';
    rosterStep.appendChild(rosterLabel);

    $timeline.append(rosterStep);

    $timeline.on('click', '.pers-timeline-step', function () {
      var stepVal = $(this).data('step');
      if (stepVal === 'roster') {
        showRosterStep();
      } else {
        navigateToStep(parseInt(stepVal));
      }
    });
  }

  function updateTimeline(activeIndex, isRoster) {
    $timeline.find('.pers-timeline-step').each(function () {
      var $el = $(this);
      var stepVal = $el.data('step');

      $el.removeClass('active completed');

      if (isRoster) {
        if (stepVal !== 'roster') {
          $el.addClass('completed');
        } else {
          $el.addClass('active');
        }
      } else {
        if (typeof stepVal === 'number' && stepVal < activeIndex) {
          $el.addClass('completed');
        } else if (stepVal === activeIndex) {
          $el.addClass('active');
        }
      }
    });
  }

  // =============================================
  // SIDEBAR (Miniaturas)
  // =============================================
  function buildSidebar() {
    $sidebar.empty();

    for (var i = 0; i < produtos.length; i++) {
      var p = produtos[i];
      var item = document.createElement('div');
      item.className = 'pers-sidebar-item';
      item.setAttribute('data-product-id', p.id);
      item.setAttribute('data-slug', p.categoria_slug);

      var img = document.createElement('img');
      img.src = p.foto;
      img.alt = p.titulo;
      item.appendChild(img);

      $sidebar.append(item);
    }

    updateSidebarActive(stepsOrder.length > 0 ? stepsOrder[0] : '');
  }

  function updateSidebarActive(slug) {
    $sidebar.find('.pers-sidebar-item').removeClass('active');
    $sidebar
      .find('.pers-sidebar-item[data-slug="' + slug + '"]')
      .addClass('active');
  }

  // =============================================
  // NAVEGAÇÃO ENTRE ETAPAS
  // =============================================
  function navigateToStep(index) {
    if (index < 0 || index >= stepsOrder.length) return;

    hideLoading();
    currentStepIndex = index;
    isRosterStep = false;

    var slug = stepsOrder[index];
    var produto = getProductBySlug(slug);

    if (!produto) return;

    $stepCustom.show().addClass('active');
    $stepRoster.hide().removeClass('active');

    $productTitle.text(produto.titulo);
    $previewProduct.attr('src', produto.foto).attr('alt', produto.titulo);

    $('.pers-ref-bar').remove();

    renderOptions(slug, produto);
    renderPriceSummary(slug, produto);

    updateTimeline(index, false);
    updateSidebarActive(slug);

    renderBottomBar();
    updateLogoOverlay(slug, produto);
    syncOptionsHeight();
  }

  function syncOptionsHeight() {
    var $list = $('#pers-options-list');
    if ($list.length === 0) return;
    if (window.innerWidth <= 760) {
      $list.css('max-height', 'none');
      return;
    }
    var $preview = $('#pers-preview');
    var previewH = $preview.outerHeight();
    var headerH = $options.find('.pers-options-header').outerHeight(true) || 0;
    var descCardH = $options.find('.pers-desc-card').outerHeight(true) || 0;
    var available = previewH - headerH - descCardH;
    if (available > 100) {
      $list.css('max-height', available + 'px');
    }
  }

  $(window).on('resize', function () {
    if (!isRosterStep) syncOptionsHeight();
  });

  function showRosterStep() {
    hideLoading();
    isRosterStep = true;

    $stepCustom.hide().removeClass('active');
    $stepRoster.show().addClass('active');

    updateTimeline(0, true);
    updateSidebarActive('');

    renderProductCards();
    renderRosterTable();
    updateOrderSummary();
    renderBottomBar();
  }

  function getProductBySlug(slug) {
    for (var i = 0; i < produtos.length; i++) {
      if (produtos[i].categoria_slug === slug) return produtos[i];
    }
    return null;
  }

  function getCategoryTitle(slug) {
    for (var i = 0; i < allCategories.length; i++) {
      if (allCategories[i].slug === slug) return allCategories[i].titulo;
    }
    return slug;
  }

  // =============================================
  // HELPERS
  // =============================================
  function getState(slug) {
    if (!personalizacao[slug]) {
      personalizacao[slug] = { items: {} };
    }
    if (!personalizacao[slug].items) {
      personalizacao[slug].items = {};
    }
    return personalizacao[slug];
  }

  function isItemAtivo(slug, persId) {
    var state = getState(slug);
    return state.items[persId] && state.items[persId].ativo;
  }

  function setItemAtivo(slug, persId, ativo) {
    var state = getState(slug);
    if (!state.items[persId]) state.items[persId] = {};
    state.items[persId].ativo = ativo;
    savePersonalizacao();
  }

  function getItemCor(slug, persId) {
    var state = getState(slug);
    return state.items[persId] && state.items[persId].cor ? state.items[persId].cor : null;
  }

  function setItemCor(slug, persId, cor) {
    var state = getState(slug);
    if (!state.items[persId]) state.items[persId] = {};
    state.items[persId].cor = cor;
    savePersonalizacao();
  }

  function getPreviewPers(produto) {
    if (!produto.personalizacoes) return null;
    for (var i = 0; i < produto.personalizacoes.length; i++) {
      var p = produto.personalizacoes[i];
      if (p.tipo === 'imagem' && p.habilitar_preview) return p;
    }
    return null;
  }

  // =============================================
  // OPÇÕES DE PERSONALIZAÇÃO (Etapa 1)
  // =============================================
  function renderDescriptionCard(produto) {
    if (!produto.texto || produto.texto.trim() === '') return null;

    var card = document.createElement('div');
    card.className = 'pers-desc-card';

    var label = document.createElement('div');
    label.className = 'pers-desc-card-label';
    label.textContent = 'Descrição';
    card.appendChild(label);

    var textEl = document.createElement('div');
    textEl.className = 'pers-desc-text';
    textEl.innerHTML = produto.texto;
    card.appendChild(textEl);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pers-desc-more';
    btn.textContent = 'Ver mais';
    $(btn).on('click', function () {
      openDescModal(produto.titulo, produto.texto);
    });
    card.appendChild(btn);

    setTimeout(function () {
      if (textEl.scrollHeight <= textEl.clientHeight + 2) {
        btn.style.display = 'none';
      }
    }, 50);

    return card;
  }

  function openDescModal(titulo, texto) {
    $('.pers-desc-modal').remove();

    var overlay = document.createElement('div');
    overlay.className = 'pers-desc-modal';

    var inner = document.createElement('div');
    inner.className = 'pers-desc-modal-inner';

    // Botão fora do body scrollável para não ser cortado pelo overflow
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'pers-ref-modal-close';
    closeBtn.innerHTML = '<i class="las la-times"></i>';
    inner.appendChild(closeBtn);

    // Wrapper com scroll
    var body = document.createElement('div');
    body.className = 'pers-desc-modal-body';

    var titleEl = document.createElement('h3');
    titleEl.className = 'pers-desc-modal-title';
    titleEl.textContent = titulo;

    var content = document.createElement('div');
    content.className = 'pers-desc-modal-content';
    content.innerHTML = texto;

    body.appendChild(titleEl);
    body.appendChild(content);
    inner.appendChild(body);
    overlay.appendChild(inner);
    document.body.appendChild(overlay);

    setTimeout(function () {
      $(overlay).addClass('open');
    }, 10);

    function closeModal() {
      $(overlay).removeClass('open');
      setTimeout(function () { $(overlay).remove(); }, 300);
    }

    $(closeBtn).on('click', closeModal);
    $(overlay).on('click', function (e) {
      if (e.target === overlay) closeModal();
    });
  }

  function renderOptions(slug, produto) {
    $options.empty();

    var descCard = renderDescriptionCard(produto);
    if (descCard) {
      $options.append(descCard);
    }

    var persList = produto.personalizacoes;
    if (!persList || persList.length === 0) {
      var noConfig = document.createElement('div');
      noConfig.className = 'pers-no-config';
      var icon = document.createElement('i');
      icon.className = 'las la-info-circle';
      noConfig.appendChild(icon);
      var msg = document.createElement('p');
      msg.textContent = 'Este produto não possui opções de personalização.';
      noConfig.appendChild(msg);
      $options.append(noConfig);
      return;
    }

    var state = getState(slug);

    // Subtítulo
    var optHeader = document.createElement('div');
    optHeader.className = 'pers-options-header';

    var optTitle = document.createElement('h3');
    optTitle.className = 'pers-options-title';
    optTitle.textContent = 'Opções de personalização';
    optHeader.appendChild(optTitle);

    var optDesc = document.createElement('p');
    optDesc.className = 'pers-options-desc';
    optDesc.textContent =
      'Selecione as opções de personalização para esta peça.';
    optHeader.appendChild(optDesc);

    if (produto.foto_referencia) {
      var refLink = document.createElement('a');
      refLink.href = '#';
      refLink.className = 'pers-ref-link';
      var refIcon = document.createElement('i');
      refIcon.className = 'las la-stamp';
      refLink.appendChild(refIcon);
      refLink.appendChild(
        document.createTextNode(' Ver locais de personalização'),
      );
      $(refLink).on('click', function (e) {
        e.preventDefault();
        openRefModal(produto.foto_referencia);
      });
      optHeader.appendChild(refLink);
    }

    $options.append(optHeader);

    // Wrapper scrollável para os itens
    var listWrap = document.createElement('div');
    listWrap.className = 'pers-options-list';
    listWrap.id = 'pers-options-list';

    // Renderizar cada personalização
    for (var i = 0; i < persList.length; i++) {
      var pers = persList[i];
      renderPersItem(slug, pers, state, produto, listWrap);
    }

    $options.append(listWrap);
  }

  function renderPersItem(slug, pers, state, produto, container) {
    var persId = pers.id;
    var section = createSection(pers.titulo, null, true, pers.local_numero);
    var body = section.querySelector('.pers-section-body');

    // Info line: descrição + valor em linha
    var infoLine = document.createElement('div');
    infoLine.className = 'pers-item-info';

    if (pers.descricao) {
      var desc = document.createElement('span');
      desc.className = 'pers-item-desc';
      desc.textContent = pers.descricao;
      infoLine.appendChild(desc);
    }

    if (pers.valor_adicional > 0) {
      var valor = document.createElement('span');
      valor.className = 'pers-item-valor';
      var valorText = '+ ' + formatCurrency(pers.valor_adicional);
      if (pers.tipo === 'numero') {
        valorText += ' /caractere';
      }
      valor.textContent = valorText;
      infoLine.appendChild(valor);
    }

    if (infoLine.childNodes.length > 0) {
      body.appendChild(infoLine);
    }

    // Controles por tipo
    if (pers.tipo === 'imagem') {
      renderImagemControl(slug, pers, body, state, produto);
    } else {
      // nome ou numero: switch ativar/desativar + seletor de cor
      var isAtivo = isItemAtivo(slug, persId);

      var colorWrap = document.createElement('div');
      colorWrap.className = 'pers-color-select';
      colorWrap.style.display = (pers.obrigatoria || isAtivo) ? 'block' : 'none';

      var colorLabel = document.createElement('div');
      colorLabel.className = 'pers-switch-label';
      colorLabel.textContent = pers.tipo === 'numero' ? 'Cor do número' : 'Cor do nome';
      colorLabel.style.marginBottom = '4px';
      colorWrap.appendChild(colorLabel);

      var colorSelect = document.createElement('select');
      colorSelect.className = 'campo';
      var currentCor = getItemCor(slug, persId);
      for (var c = 0; c < CORES_PERSONALIZACAO.length; c++) {
        var opt = document.createElement('option');
        opt.value = CORES_PERSONALIZACAO[c];
        opt.textContent = CORES_PERSONALIZACAO[c];
        if (currentCor === CORES_PERSONALIZACAO[c]) opt.selected = true;
        colorSelect.appendChild(opt);
      }
      if (!currentCor) {
        setItemCor(slug, persId, CORES_PERSONALIZACAO[0]);
      }
      $(colorSelect).on('change', function () {
        setItemCor(slug, persId, this.value);
      });
      colorWrap.appendChild(colorSelect);

      var switchRow = createSwitchRow(
        pers.obrigatoria ? 'Ativado (obrigatório)' : 'Ativar personalização',
        pers.obrigatoria ? true : isAtivo,
        function (checked) {
          setItemAtivo(slug, persId, checked);
          $(colorWrap).toggle(checked);
          renderPriceSummary(slug, produto);
        },
      );
      if (pers.obrigatoria) {
        setItemAtivo(slug, persId, true);
        var input = switchRow.querySelector('input');
        if (input) input.disabled = true;
      }
      body.appendChild(switchRow);
      body.appendChild(colorWrap);
    }

    if (container) {
      container.appendChild(section);
    } else {
      $options.append(section);
    }
  }

  function renderImagemControl(slug, pers, body, state, produto) {
    var persId = pers.id;
    var upload = logoUploads[slug + '_' + persId] || null;
    var isAtivo = upload ? true : isItemAtivo(slug, persId);

    // Upload area (criado antes do switch para referência no callback)
    var uploadWrap = document.createElement('div');
    uploadWrap.className = 'pers-upload-area';
    uploadWrap.style.display = (pers.obrigatoria || isAtivo) ? 'block' : 'none';

    var uploadLabel = document.createElement('label');
    uploadLabel.className = 'pers-upload-btn';
    var uploadIcon = document.createElement('i');
    uploadIcon.className = 'las la-cloud-upload-alt';
    uploadLabel.appendChild(uploadIcon);
    uploadLabel.appendChild(document.createTextNode('Escolher arquivo'));

    var fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.style.display = 'none';
    fileInput.id = 'pers-img-input-' + slug + '-' + persId;
    uploadLabel.setAttribute('for', fileInput.id);

    uploadWrap.appendChild(uploadLabel);
    uploadWrap.appendChild(fileInput);

    var previewDiv = document.createElement('div');
    previewDiv.className = 'pers-upload-preview';
    previewDiv.style.display = 'none';
    uploadWrap.appendChild(previewDiv);

    var info = document.createElement('div');
    info.className = 'pers-upload-info';
    var infoIcon = document.createElement('i');
    infoIcon.className = 'las la-info-circle';
    info.appendChild(infoIcon);
    info.appendChild(document.createTextNode('JPG, PNG, SVG ou WebP. Máx. 5MB.'));
    uploadWrap.appendChild(info);

    // Switch ativar/desativar
    var switchRow = createSwitchRow(
      pers.obrigatoria ? 'Ativado (obrigatório)' : 'Ativar personalização',
      pers.obrigatoria ? true : isAtivo,
      function (checked) {
        setItemAtivo(slug, persId, checked);
        $(uploadWrap).toggle(checked);
        if (!checked && pers.habilitar_preview) {
          $previewLogo.hide();
        } else if (checked && pers.habilitar_preview) {
          updateLogoOverlay(slug, produto);
        }
        renderPriceSummary(slug, produto);
      }
    );
    if (pers.obrigatoria) {
      setItemAtivo(slug, persId, true);
      var inp = switchRow.querySelector('input');
      if (inp) inp.disabled = true;
    }
    body.appendChild(switchRow);
    body.appendChild(uploadWrap);

    // Restaurar preview do arquivo se existir
    if (upload && upload.url) {
      populatePreview(previewDiv, upload.url, upload.filename, persId, slug, produto);
      setItemAtivo(slug, persId, true);
    }

    // Handler de upload
    (function (pId, pvDiv) {
      $(fileInput).on('change', function () {
        var file = this.files[0];
        if (!file) return;

        var formData = new FormData();
        formData.append('logo', file);

        $.ajax({
          url: apiUrl + '?acao=upload_logo',
          type: 'POST',
          data: formData,
          processData: false,
          contentType: false,
          dataType: 'json',
        })
          .done(function (resp) {
            if (resp.status === 'ok') {
              logoUploads[slug + '_' + pId] = {
                filename: resp.filename,
                url: resp.url,
              };
              populatePreview(pvDiv, resp.url, resp.filename, pId, slug, produto);
              setItemAtivo(slug, pId, true);
              if (pers.habilitar_preview) {
                updateLogoOverlay(slug, produto);
              }
              renderPriceSummary(slug, produto);
            } else {
              if (typeof showAlert === 'function') {
                showAlert('Erro', resp.message || 'Erro ao enviar logo.', 'error');
              }
            }
          })
          .fail(function () {
            if (typeof showAlert === 'function') {
              showAlert('Erro', 'Erro ao enviar arquivo.', 'error');
            }
          });
      });
    })(persId, previewDiv);
  }

  function populatePreview(el, url, filename, persId, slug, produto) {
    var $el = $(el);
    $el.empty().show();

    var img = document.createElement('img');
    img.src = url;
    img.alt = 'Logo';
    el.appendChild(img);

    var nameSpan = document.createElement('span');
    nameSpan.className = 'pers-upload-name';
    nameSpan.textContent = filename;
    el.appendChild(nameSpan);

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'pers-upload-remove';
    var removeIcon = document.createElement('i');
    removeIcon.className = 'las la-times';
    removeBtn.appendChild(removeIcon);
    el.appendChild(removeBtn);

    $(removeBtn).on('click', function () {
      delete logoUploads[slug + '_' + persId];
      $el.hide().empty();
      $previewLogo.hide();
      setItemAtivo(slug, persId, false);
      renderPriceSummary(slug, produto);
    });
  }

  // Wrapper de compatibilidade
  function showUploadPreview(url, filename, persId, slug, produto, containerEl) {
    populatePreview(
      containerEl || document.getElementById('pers-upload-preview-' + persId),
      url, filename, persId, slug, produto
    );
  }

  function getPersIcon(tipo) {
    if (tipo === 'imagem') return 'la-image';
    if (tipo === 'nome') return 'la-user-edit';
    if (tipo === 'numero') return 'la-hashtag';
    return 'la-cog';
  }

  // Helper: criar seção colapsável
  function createSection(title, iconClass, openByDefault, localNumero) {
    var section = document.createElement('div');
    section.className = 'pers-section' + (openByDefault ? ' open' : '');

    var header = document.createElement('div');
    header.className = 'pers-section-header';

    var titleDiv = document.createElement('div');
    titleDiv.className = 'pers-section-title';

    if (localNumero) {
      var badge = document.createElement('span');
      badge.className = 'pers-local-badge';
      badge.textContent = localNumero;
      titleDiv.appendChild(badge);
    } else if (iconClass) {
      var icon = document.createElement('i');
      icon.className = 'las ' + iconClass;
      titleDiv.appendChild(icon);
    }
    titleDiv.appendChild(document.createTextNode(title));

    var toggle = document.createElement('i');
    toggle.className = 'las la-angle-down pers-section-toggle';

    header.appendChild(titleDiv);
    header.appendChild(toggle);

    var body = document.createElement('div');
    body.className = 'pers-section-body';

    section.appendChild(header);
    section.appendChild(body);

    $(header).on('click', function () {
      $(section).toggleClass('open');
    });

    return section;
  }

  // Helper: criar switch row
  function createSwitchRow(labelText, checked, onChange) {
    var row = document.createElement('div');
    row.className = 'pers-switch-row';

    var label = document.createElement('span');
    label.className = 'pers-switch-label';
    label.textContent = labelText;

    var switchWrap = document.createElement('label');
    switchWrap.className = 'pers-switch';

    var input = document.createElement('input');
    input.type = 'checkbox';
    input.checked = !!checked;

    var slider = document.createElement('span');
    slider.className = 'pers-switch-slider';

    switchWrap.appendChild(input);
    switchWrap.appendChild(slider);

    row.appendChild(label);
    row.appendChild(switchWrap);

    $(input).on('change', function () {
      onChange(this.checked);
    });

    $(label).on('click', function () {
      if (!input.disabled) {
        input.checked = !input.checked;
        $(input).trigger('change');
      }
    });

    return row;
  }

  // =============================================
  // UPLOAD PREVIEW
  // =============================================
  function showUploadPreview(
    url,
    filename,
    persId,
    slug,
    produto,
    containerEl,
  ) {
    var $preview = containerEl
      ? $(containerEl)
      : $('#pers-upload-preview-' + persId);
    $preview.empty().show();

    var img = document.createElement('img');
    img.src = url;
    img.alt = 'Logo';
    $preview.append(img);

    var nameSpan = document.createElement('span');
    nameSpan.className = 'pers-upload-name';
    nameSpan.textContent = filename;
    $preview.append(nameSpan);

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'pers-upload-remove';

    var removeIcon = document.createElement('i');
    removeIcon.className = 'las la-times';
    removeBtn.appendChild(removeIcon);
    $preview.append(removeBtn);

    $(removeBtn).on('click', function () {
      delete logoUploads[slug + '_' + persId];
      $preview.hide().empty();
      $previewLogo.hide();
      setItemAtivo(slug, persId, false);
      renderPriceSummary(slug, produto);
    });
  }

  // =============================================
  // LOGO OVERLAY (Drag & Resize)
  // =============================================
  function updateLogoOverlay(slug, produto) {
    var previewPers = getPreviewPers(produto);
    if (!previewPers) {
      $previewLogo.hide();
      return;
    }

    var persId = previewPers.id;
    var upload = logoUploads[slug + '_' + persId];
    if (!upload || !upload.url) {
      $previewLogo.hide();
      return;
    }

    $previewLogoImg.attr('src', upload.url);
    $previewLogo.show();

    var state = getState(slug);
    if (state.logo_posicao) {
      $previewLogo.css({
        left: state.logo_posicao.x + '%',
        top: state.logo_posicao.y + '%',
        width: state.logo_posicao.w + '%',
      });
    } else {
      $previewLogo.css({
        left: '40%',
        top: '35%',
        width: '20%',
      });
    }

    setupDragAndResize();
  }

  function setupDragAndResize() {
    var $container = $('#pers-preview-container');
    var $logo = $previewLogo;
    var $handle = $('#pers-preview-logo-resize');

    var isDragging = false;
    var isResizing = false;
    var startX, startY, startLeft, startTop, startWidth;

    $logo
      .off('mousedown.drag touchstart.drag')
      .on('mousedown.drag touchstart.drag', function (e) {
        if (
          $(e.target).is($handle) ||
          $(e.target).closest('.pers-preview-logo-resize').length
        )
          return;
        e.preventDefault();
        isDragging = true;
        $logo.addClass('dragging');

        var coords = getEventCoords(e);
        startX = coords.x;
        startY = coords.y;
        startLeft = parseFloat($logo.css('left')) || 0;
        startTop = parseFloat($logo.css('top')) || 0;
      });

    $handle
      .off('mousedown.resize touchstart.resize')
      .on('mousedown.resize touchstart.resize', function (e) {
        e.preventDefault();
        e.stopPropagation();
        isResizing = true;

        var coords = getEventCoords(e);
        startX = coords.x;
        startWidth = $logo.outerWidth();
      });

    $(document)
      .off('mousemove.pers touchmove.pers')
      .on('mousemove.pers touchmove.pers', function (e) {
        if (!isDragging && !isResizing) return;
        e.preventDefault();

        var coords = getEventCoords(e);
        var containerW = $container.width();
        var containerH = $container.height();

        if (isDragging) {
          var dx = coords.x - startX;
          var dy = coords.y - startY;
          var newLeft = Math.max(
            0,
            Math.min(startLeft + dx, containerW - $logo.outerWidth()),
          );
          var newTop = Math.max(
            0,
            Math.min(startTop + dy, containerH - $logo.outerHeight()),
          );
          $logo.css({ left: newLeft + 'px', top: newTop + 'px' });
        }

        if (isResizing) {
          var dx2 = coords.x - startX;
          var newWidth = Math.max(
            30,
            Math.min(startWidth + dx2, containerW * 0.6),
          );
          $logo.css({ width: newWidth + 'px' });
        }
      });

    $(document)
      .off('mouseup.pers touchend.pers')
      .on('mouseup.pers touchend.pers', function () {
        if (isDragging || isResizing) {
          isDragging = false;
          isResizing = false;
          $logo.removeClass('dragging');
          saveLogoPosition();
        }
      });
  }

  function saveLogoPosition() {
    var $container = $('#pers-preview-container');
    var containerW = $container.width();
    var containerH = $container.height();

    var slug = stepsOrder[currentStepIndex];
    if (!personalizacao[slug]) return;

    personalizacao[slug].logo_posicao = {
      x: ((parseFloat($previewLogo.css('left')) / containerW) * 100).toFixed(2),
      y: ((parseFloat($previewLogo.css('top')) / containerH) * 100).toFixed(2),
      w: (($previewLogo.outerWidth() / containerW) * 100).toFixed(2),
    };
    savePersonalizacao();
  }

  function getEventCoords(e) {
    var ev = e.originalEvent || e;
    if (ev.touches && ev.touches.length > 0) {
      return { x: ev.touches[0].clientX, y: ev.touches[0].clientY };
    }
    return { x: ev.clientX, y: ev.clientY };
  }

  // =============================================
  // RESUMO DE PREÇO (Etapa 1)
  // =============================================
  function renderPriceSummary(slug, produto) {
    $priceSummary.empty();

    // Preço base
    var baseRow = document.createElement('div');
    baseRow.className = 'pers-price-row';
    var baseLabel = document.createElement('span');
    baseLabel.textContent = 'Preço do produto:';
    var baseVal = document.createElement('span');
    baseVal.textContent = formatCurrency(produto.valor);
    baseRow.appendChild(baseLabel);
    baseRow.appendChild(baseVal);
    $priceSummary.append(baseRow);

    var totalPers = 0;

    if (produto.personalizacoes) {
      for (var i = 0; i < produto.personalizacoes.length; i++) {
        var pers = produto.personalizacoes[i];
        if (!isItemAtivo(slug, pers.id)) continue;
        if (pers.valor_adicional <= 0) continue;

        var row = document.createElement('div');
        row.className = 'pers-price-row pers-price-addon';
        var label = document.createElement('span');
        label.textContent = '+ ' + pers.titulo + ':';
        var val = document.createElement('span');

        if (pers.tipo === 'numero') {
          val.textContent = formatCurrency(pers.valor_adicional) + '/car.';
        } else {
          val.textContent = formatCurrency(pers.valor_adicional);
          totalPers += pers.valor_adicional;
        }

        row.appendChild(label);
        row.appendChild(val);
        $priceSummary.append(row);
      }
    }

    var totalRow = document.createElement('div');
    totalRow.className = 'pers-price-row total';
    var totalLabel = document.createElement('span');
    totalLabel.textContent = 'Total por unidade:';
    var totalVal = document.createElement('span');
    var totalText = formatCurrency(produto.valor + totalPers);
    // Indicar se há custo variável (número)
    var hasNumero = hasActivePersByTipo(slug, produto, 'numero');
    if (hasNumero) totalText += ' + nº';
    totalVal.textContent = totalText;
    totalRow.appendChild(totalLabel);
    totalRow.appendChild(totalVal);
    $priceSummary.append(totalRow);
  }

  function hasActivePersByTipo(slug, produto, tipo) {
    if (!produto.personalizacoes) return false;
    for (var i = 0; i < produto.personalizacoes.length; i++) {
      var p = produto.personalizacoes[i];
      if (p.tipo === tipo && isItemAtivo(slug, p.id) && p.valor_adicional > 0)
        return true;
    }
    return false;
  }

  // =============================================
  // BARRA INFERIOR
  // =============================================
  function renderBottomBar() {
    $bottomBar.find('.pers-btn-submit').remove();
    $btnNext.show();

    if (isRosterStep) {
      $btnPrev.show();
      $btnNext.hide();

      var submitBtn = document.createElement('button');
      submitBtn.className = 'pers-btn-submit btn btn-primario disabled';
      submitBtn.type = 'button';
      submitBtn.id = 'pers-btn-submit';

      submitBtn.appendChild(document.createTextNode('Solicitar Pedido '));
      var submitIcon = document.createElement('i');
      submitIcon.className = 'las la-check';
      submitBtn.appendChild(submitIcon);

      $bottomBar.append(submitBtn);
      validateOrder();
    } else {
      $btnPrev.show();
      $btnNext.show();
    }
  }

  $btnNext.on('click', function () {
    if (isRosterStep) return;

    capturePreview(stepsOrder[currentStepIndex]);

    if (currentStepIndex < stepsOrder.length - 1) {
      navigateToStep(currentStepIndex + 1);
    } else {
      showRosterStep();
    }
  });

  $btnPrev.on('click.nav', function () {
    if (isRosterStep) {
      if (stepsOrder.length > 0) {
        navigateToStep(stepsOrder.length - 1);
      } else {
        window.location.href = siteUrl + 'minha-conta/produtos';
      }
      return;
    }

    if (currentStepIndex > 0) {
      navigateToStep(currentStepIndex - 1);
    } else {
      window.location.href = siteUrl + 'minha-conta/produtos';
    }
  });

  $(document).on('click', '#pers-btn-submit', function () {
    submitOrder();
  });

  // =============================================
  // CAPTURAR PRÉ-VISUALIZAÇÃO (Canvas)
  // =============================================
  function capturePreview(slug) {
    var $container = $('#pers-preview-container');
    if ($container.length === 0) return;

    var canvas = document.createElement('canvas');
    var containerW = $container.width();
    var containerH = $container.height();
    canvas.width = containerW;
    canvas.height = containerH;
    var ctx = canvas.getContext('2d');

    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    var productImg = $previewProduct[0];
    if (productImg && productImg.complete && productImg.naturalWidth > 0) {
      var prodW = containerW * 0.85;
      var prodH = containerH * 0.85;
      var ratio = Math.min(
        prodW / productImg.naturalWidth,
        prodH / productImg.naturalHeight,
      );
      var drawW = productImg.naturalWidth * ratio;
      var drawH = productImg.naturalHeight * ratio;
      var drawX = (containerW - drawW) / 2;
      var drawY = (containerH - drawH) / 2;

      try {
        ctx.drawImage(productImg, drawX, drawY, drawW, drawH);
      } catch (e) {
        /* CORS */
      }
    }

    if ($previewLogo.is(':visible')) {
      var logoImg = $previewLogoImg[0];
      if (logoImg && logoImg.complete && logoImg.naturalWidth > 0) {
        var logoLeft = parseFloat($previewLogo.css('left')) || 0;
        var logoTop = parseFloat($previewLogo.css('top')) || 0;
        var logoW = $previewLogo.outerWidth();
        var logoH = $previewLogo.outerHeight();

        try {
          ctx.drawImage(logoImg, logoLeft, logoTop, logoW, logoH);
        } catch (e) {
          /* CORS */
        }
      }
    }

    try {
      var base64 = canvas.toDataURL('image/png', 0.8);
      if (!personalizacao[slug]) personalizacao[slug] = {};
      personalizacao[slug].preview_base64 = base64;
      savePersonalizacao();
    } catch (e) {
      /* CORS */
    }
  }

  // =============================================
  // ETAPA 2: CARDS DOS PRODUTOS
  // =============================================
  function renderProductCards() {
    $productCards.empty();

    for (var i = 0; i < produtos.length; i++) {
      var p = produtos[i];

      var card = document.createElement('div');
      card.className = 'pers-product-card';

      var imgDiv = document.createElement('div');
      imgDiv.className = 'pers-product-card-img';

      var img = document.createElement('img');
      img.src = p.foto;
      img.alt = p.titulo;
      imgDiv.appendChild(img);

      var infoDiv = document.createElement('div');
      infoDiv.className = 'pers-product-card-info';

      var name = document.createElement('div');
      name.className = 'pers-product-card-name';
      name.textContent = p.titulo;
      infoDiv.appendChild(name);

      var price = document.createElement('div');
      price.className = 'pers-product-card-price';
      price.textContent = formatCurrency(p.valor);
      infoDiv.appendChild(price);

      card.appendChild(imgDiv);
      card.appendChild(infoDiv);
      $productCards.append(card);
    }
  }

  // =============================================
  // ETAPA 2: TABELA DO PLANTEL
  // =============================================
  function renderRosterTable() {
    var hasNome = false;
    var hasNumero = false;

    for (var i = 0; i < produtos.length; i++) {
      var slug = produtos[i].categoria_slug;
      var persList = produtos[i].personalizacoes || [];
      for (var k = 0; k < persList.length; k++) {
        if (persList[k].tipo === 'nome' && isItemAtivo(slug, persList[k].id))
          hasNome = true;
        if (persList[k].tipo === 'numero' && isItemAtivo(slug, persList[k].id))
          hasNumero = true;
      }
    }

    $rosterThead.empty();
    var headRow = document.createElement('tr');

    var thQtd = document.createElement('th');
    thQtd.textContent = 'Qtd';
    headRow.appendChild(thQtd);

    if (hasNome) {
      var thNome = document.createElement('th');
      thNome.textContent = 'Nome';
      headRow.appendChild(thNome);
    }

    if (hasNumero) {
      var thNum = document.createElement('th');
      thNum.textContent = 'Número';
      headRow.appendChild(thNum);
    }

    for (var i = 0; i < produtos.length; i++) {
      var p = produtos[i];
      if (p.tem_variacoes) {
        var thProd = document.createElement('th');
        thProd.className = 'pers-roster-th-product';

        var thInner = document.createElement('div');
        thInner.style.cssText = 'display:flex;align-items:center;gap:5px;';

        if (p.icone_svg) {
          var iconWrap = document.createElement('span');
          iconWrap.className = 'cat-icon-svg-wrap';
          iconWrap.innerHTML = p.icone_svg;
          thInner.appendChild(iconWrap);
        }
        thInner.appendChild(document.createTextNode(p.categoria_titulo));
        thProd.appendChild(thInner);
        headRow.appendChild(thProd);
      }
    }

    var thAction = document.createElement('th');
    thAction.style.width = '40px';
    headRow.appendChild(thAction);

    $rosterThead.append(headRow);

    if (jogadores.length === 0) {
      jogadores.push(createEmptyJogador());
    }

    $rosterTbody.empty();
    for (var j = 0; j < jogadores.length; j++) {
      renderRosterRow(j, hasNome, hasNumero);
    }

    validateOrder();
  }

  function createEmptyJogador() {
    return { quantidade: 1, nome: '', numero: '', variacoes: {} };
  }

  function renderRosterRow(index, hasNome, hasNumero) {
    var jog = jogadores[index];
    var row = document.createElement('tr');
    row.setAttribute('data-index', index);

    var tdQtd = document.createElement('td');
    var qtyWrap = document.createElement('div');
    qtyWrap.className = 'pers-roster-qty';

    var btnMinus = document.createElement('button');
    btnMinus.type = 'button';
    btnMinus.textContent = '−';
    $(btnMinus).on('click', function () {
      var input = $(this).siblings('input')[0];
      var val = parseInt(input.value) || 1;
      if (val > 1) {
        input.value = val - 1;
        jog.quantidade = val - 1;
        updateOrderSummary();
      }
    });

    var qtyInput = document.createElement('input');
    qtyInput.type = 'number';
    qtyInput.min = '1';
    qtyInput.max = '999';
    qtyInput.value = jog.quantidade || 1;
    $(qtyInput).on('change', function () {
      var val = Math.max(1, parseInt(this.value) || 1);
      this.value = val;
      jog.quantidade = val;
      updateOrderSummary();
    });

    var btnPlus = document.createElement('button');
    btnPlus.type = 'button';
    btnPlus.textContent = '+';
    $(btnPlus).on('click', function () {
      var input = $(this).siblings('input')[0];
      var val = parseInt(input.value) || 1;
      input.value = val + 1;
      jog.quantidade = val + 1;
      updateOrderSummary();
    });

    qtyWrap.appendChild(btnMinus);
    qtyWrap.appendChild(qtyInput);
    qtyWrap.appendChild(btnPlus);
    tdQtd.appendChild(qtyWrap);
    row.appendChild(tdQtd);

    if (hasNome) {
      var tdNome = document.createElement('td');
      var nomeInput = document.createElement('input');
      nomeInput.type = 'text';
      nomeInput.className = 'pers-roster-input';
      nomeInput.placeholder = 'Nome';
      nomeInput.value = jog.nome || '';
      nomeInput.maxLength = 20;
      $(nomeInput).on('input', function () {
        jog.nome = this.value;
      });
      tdNome.appendChild(nomeInput);
      row.appendChild(tdNome);
    }

    if (hasNumero) {
      var tdNum = document.createElement('td');
      var numInput = document.createElement('input');
      numInput.type = 'text';
      numInput.className = 'pers-roster-input';
      numInput.placeholder = 'Nº';
      numInput.value = jog.numero || '';
      numInput.maxLength = 4;
      numInput.setAttribute('inputmode', 'numeric');
      numInput.setAttribute('pattern', '[0-9]*');
      numInput.style.width = '70px';
      numInput.style.minWidth = '50px';
      $(numInput).on('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '').slice(0, 4);
        jog.numero = this.value;
        updateOrderSummary();
      });
      tdNum.appendChild(numInput);
      row.appendChild(tdNum);
    }

    for (var i = 0; i < produtos.length; i++) {
      var p = produtos[i];
      if (p.tem_variacoes) {
        var tdVar = document.createElement('td');
        tdVar.style.textAlign = 'center';
        var select = document.createElement('select');
        select.className = 'pers-roster-select';
        select.setAttribute('data-product-id', p.id);

        var optDefault = document.createElement('option');
        optDefault.value = '';
        optDefault.textContent = 'Selecionar';
        select.appendChild(optDefault);

        for (var v = 0; v < p.variacoes.length; v++) {
          var varItem = p.variacoes[v];
          var opt = document.createElement('option');
          opt.value = varItem.id;
          opt.textContent =
            varItem.titulo + ' (Máx. ' + varItem.estoque + ' unid.)';

          if (
            jog.variacoes &&
            jog.variacoes[p.id] &&
            jog.variacoes[p.id] == varItem.id
          ) {
            opt.selected = true;
          }
          select.appendChild(opt);
        }

        (function (prodId) {
          $(select).on('change', function () {
            if (!jog.variacoes) jog.variacoes = {};
            jog.variacoes[prodId] = this.value ? parseInt(this.value) : null;
          });
        })(p.id);

        tdVar.appendChild(select);
        row.appendChild(tdVar);
      }
    }

    var tdRemove = document.createElement('td');
    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'pers-roster-remove';
    var removeIcon = document.createElement('i');
    removeIcon.className = 'las la-times';
    removeBtn.appendChild(removeIcon);

    (function (idx) {
      $(removeBtn).on('click', function () {
        if (jogadores.length <= 1) return;
        jogadores.splice(idx, 1);
        renderRosterTable();
        updateOrderSummary();
      });
    })(index);

    tdRemove.appendChild(removeBtn);
    row.appendChild(tdRemove);
    $rosterTbody.append(row);
  }

  $('#pers-roster-add').on('click', function () {
    if (jogadores.length >= MAX_JOGADORES) {
      if (typeof showAlert === 'function') {
        showAlert(
          'Limite atingido',
          'Máximo de ' + MAX_JOGADORES + ' integrantes.',
          'warning',
        );
      }
      return;
    }
    jogadores.push(createEmptyJogador());
    renderRosterTable();
    updateOrderSummary();
  });

  // =============================================
  // ETAPA 2: RESUMO DO PEDIDO
  // =============================================
  function updateOrderSummary() {
    $orderSummary.empty();

    var title = document.createElement('div');
    title.className = 'pers-order-summary-title';
    title.textContent = 'Resumo do pedido';
    $orderSummary.append(title);

    var qtdTotal = 0;
    for (var j = 0; j < jogadores.length; j++) {
      qtdTotal += Math.max(1, jogadores[j].quantidade || 1);
    }

    var grandTotal = 0;

    for (var i = 0; i < produtos.length; i++) {
      var p = produtos[i];
      var slug = p.categoria_slug;
      var baseSubtotal = p.valor * qtdTotal;
      grandTotal += baseSubtotal;

      var line = document.createElement('div');
      line.className = 'pers-order-line';

      var lineName = document.createElement('span');
      lineName.className = 'pers-order-line-name';
      lineName.textContent = p.titulo;
      line.appendChild(lineName);

      var lineDetail = document.createElement('span');
      lineDetail.className = 'pers-order-line-detail';

      var linePrice = document.createElement('span');
      linePrice.textContent = formatCurrency(p.valor);
      lineDetail.appendChild(linePrice);

      var lineQty = document.createElement('span');
      lineQty.className = 'pers-order-line-qty';
      lineQty.textContent = 'x' + qtdTotal;
      lineDetail.appendChild(lineQty);

      var lineTotal = document.createElement('span');
      lineTotal.className = 'pers-order-line-total';
      lineTotal.textContent = formatCurrency(baseSubtotal);
      lineDetail.appendChild(lineTotal);

      line.appendChild(lineDetail);
      $orderSummary.append(line);

      // Personalizações ativas com valor
      if (p.personalizacoes) {
        for (var k = 0; k < p.personalizacoes.length; k++) {
          var pers = p.personalizacoes[k];
          if (!isItemAtivo(slug, pers.id) || pers.valor_adicional <= 0)
            continue;

          var persLine = document.createElement('div');
          persLine.className = 'pers-order-line pers-order-line-addon';

          var persName = document.createElement('span');
          persName.className = 'pers-order-line-name';
          persName.textContent = '   + ' + pers.titulo;
          persLine.appendChild(persName);

          var persDetail = document.createElement('span');
          persDetail.className = 'pers-order-line-detail';

          if (pers.tipo === 'numero') {
            // Calcular custo total do número: valor × caracteres de cada jogador × quantidade
            var numTotal = 0;
            for (var jj = 0; jj < jogadores.length; jj++) {
              var numLen = (jogadores[jj].numero || '').length;
              var jogQtd = Math.max(1, jogadores[jj].quantidade || 1);
              numTotal += pers.valor_adicional * numLen * jogQtd;
            }

            var numPrice = document.createElement('span');
            numPrice.textContent =
              formatCurrency(pers.valor_adicional) + '/car.';
            persDetail.appendChild(numPrice);

            var numTotalSpan = document.createElement('span');
            numTotalSpan.className = 'pers-order-line-total';
            numTotalSpan.textContent = formatCurrency(numTotal);
            persDetail.appendChild(numTotalSpan);

            grandTotal += numTotal;
          } else {
            var persPrice = document.createElement('span');
            persPrice.textContent = formatCurrency(pers.valor_adicional);
            persDetail.appendChild(persPrice);

            var persQty = document.createElement('span');
            persQty.className = 'pers-order-line-qty';
            persQty.textContent = 'x' + qtdTotal;
            persDetail.appendChild(persQty);

            var persTotal = pers.valor_adicional * qtdTotal;
            var persTotalSpan = document.createElement('span');
            persTotalSpan.className = 'pers-order-line-total';
            persTotalSpan.textContent = formatCurrency(persTotal);
            persDetail.appendChild(persTotalSpan);

            grandTotal += persTotal;
          }

          persLine.appendChild(persDetail);
          $orderSummary.append(persLine);
        }
      }
    }

    var totalRow = document.createElement('div');
    totalRow.className = 'pers-order-total';

    var totalLabel = document.createElement('span');
    totalLabel.textContent = 'Total a pagar:';
    totalRow.appendChild(totalLabel);

    var totalVal = document.createElement('span');
    totalVal.textContent = formatCurrency(grandTotal);
    totalRow.appendChild(totalVal);

    $orderSummary.append(totalRow);
  }

  // =============================================
  // VALIDAÇÃO DO PEDIDO
  // =============================================
  function validateOrder() {
    var $btn = $('#pers-btn-submit');
    if ($btn.length === 0) return;

    var valid = jogadores.length > 0;

    if (valid) {
      outer: for (var j = 0; j < jogadores.length; j++) {
        for (var i = 0; i < produtos.length; i++) {
          if (produtos[i].tem_variacoes) {
            var sel =
              jogadores[j].variacoes && jogadores[j].variacoes[produtos[i].id];
            if (!sel) {
              valid = false;
              break outer;
            }
          }
        }
      }
    }

    $btn.toggleClass('disabled', !valid);
  }

  $(document).on('change', '.pers-roster-select', validateOrder);

  // =============================================
  // SOLICITAR PEDIDO
  // =============================================
  function submitOrder() {
    if (jogadores.length === 0) {
      if (typeof showAlert === 'function') {
        showAlert('Atenção', 'Adicione pelo menos um jogador.', 'warning');
      }
      return;
    }

    for (var j = 0; j < jogadores.length; j++) {
      for (var i = 0; i < produtos.length; i++) {
        if (produtos[i].tem_variacoes) {
          var selected =
            jogadores[j].variacoes && jogadores[j].variacoes[produtos[i].id];
          if (!selected) {
            if (typeof showAlert === 'function') {
              showAlert(
                'Atenção',
                'Selecione o tamanho de ' +
                  produtos[i].categoria_titulo +
                  ' para todos os jogadores.',
                'warning',
              );
            }
            return;
          }
        }
      }
    }

    // Calcular valor total
    var qtdTotal = 0;
    for (var k = 0; k < jogadores.length; k++) {
      qtdTotal += Math.max(1, jogadores[k].quantidade || 1);
    }

    var valorTotal = 0;
    var produtosPayload = [];

    for (var p = 0; p < produtos.length; p++) {
      var prod = produtos[p];
      var slug = prod.categoria_slug;
      var state = getState(slug);
      valorTotal += prod.valor * qtdTotal;

      // Montar array de personalizações ativas
      var persPayload = [];
      var firstLogoFilename = null;

      if (prod.personalizacoes) {
        for (var pi = 0; pi < prod.personalizacoes.length; pi++) {
          var pers = prod.personalizacoes[pi];
          var ativo = isItemAtivo(slug, pers.id) ? 1 : 0;
          if (!ativo) continue;

          var persItem = {
            personalizacao_id: pers.id,
            tipo: pers.tipo,
            ativo: 1,
            arquivo: null,
            cor: null,
          };

          if (pers.tipo === 'nome' || pers.tipo === 'numero') {
            persItem.cor = getItemCor(slug, pers.id) || CORES_PERSONALIZACAO[0];
          }

          if (pers.tipo === 'imagem') {
            var uploadKey = slug + '_' + pers.id;
            if (logoUploads[uploadKey]) {
              persItem.arquivo = logoUploads[uploadKey].filename;
              if (!firstLogoFilename)
                firstLogoFilename = logoUploads[uploadKey].filename;
            }
          }

          // Somar valores (exceto numero que depende dos jogadores)
          if (pers.valor_adicional > 0 && pers.tipo !== 'numero') {
            valorTotal += pers.valor_adicional * qtdTotal;
          }

          if (pers.tipo === 'numero' && pers.valor_adicional > 0) {
            for (var jj = 0; jj < jogadores.length; jj++) {
              var numLen = (jogadores[jj].numero || '').length;
              var jogQtd = Math.max(1, jogadores[jj].quantidade || 1);
              valorTotal += pers.valor_adicional * numLen * jogQtd;
            }
          }

          persPayload.push(persItem);
        }
      }

      var logoPos = state.logo_posicao
        ? JSON.stringify(state.logo_posicao)
        : null;

      produtosPayload.push({
        produto_id: prod.id,
        categoria_id: prod.categoria_id,
        categoria_slug: slug,
        valor_unitario: prod.valor,
        personalizacoes: persPayload,
        logomarca_posicao: logoPos,
        preview_base64: state.preview_base64 || null,
      });
    }

    var jogadoresPayload = [];
    for (var jj2 = 0; jj2 < jogadores.length; jj2++) {
      var jog = jogadores[jj2];
      var vars = [];
      for (var prodId in jog.variacoes) {
        if (jog.variacoes.hasOwnProperty(prodId) && jog.variacoes[prodId]) {
          vars.push({
            produto_id: parseInt(prodId),
            variacao_id: parseInt(jog.variacoes[prodId]),
          });
        }
      }
      jogadoresPayload.push({
        quantidade: Math.max(1, jog.quantidade || 1),
        nome: jog.nome || '',
        numero: jog.numero || '',
        variacoes: vars,
      });
    }

    // Determinar logo_arquivo principal (primeiro upload de imagem encontrado)
    var logoArquivoGlobal = null;
    for (var lk in logoUploads) {
      if (logoUploads.hasOwnProperty(lk) && logoUploads[lk]) {
        logoArquivoGlobal = logoUploads[lk].filename;
        break;
      }
    }

    var payload = {
      produtos: produtosPayload,
      jogadores: jogadoresPayload,
      valor_total: valorTotal,
      logo_arquivo: logoArquivoGlobal,
    };

    var $btn = $('#pers-btn-submit');
    $btn.addClass('disabled');
    $btn.text('Enviando...');

    $.ajax({
      url: apiUrl + '?acao=solicitar_pedido',
      type: 'POST',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(payload),
      dataType: 'json',
    })
      .done(function (resp) {
        if (resp.status === 'ok') {
          try {
            localStorage.removeItem(LOCAL_KEY);
            localStorage.removeItem(LOCAL_PERS_KEY);
          } catch (e) {
            /* ignore */
          }

          if (typeof showAlert === 'function') {
            showAlert(
              'Sucesso!',
              resp.message || 'Pedido solicitado com sucesso!',
              'success',
            );
          }

          setTimeout(function () {
            window.location.href = siteUrl + 'minha-conta/inicio';
          }, 2000);
        } else {
          $btn.removeClass('disabled');
          $btn.text('Solicitar Pedido');
          if (typeof showAlert === 'function') {
            showAlert(
              'Erro',
              resp.message || 'Erro ao processar o pedido.',
              'error',
            );
          }
        }
      })
      .fail(function () {
        $btn.removeClass('disabled');
        $btn.text('Solicitar Pedido');
        if (typeof showAlert === 'function') {
          showAlert('Erro', 'Erro de comunicação. Tente novamente.', 'error');
        }
      });
  }

  // =============================================
  // MODAL DE REFERÊNCIA
  // =============================================
  function openRefModal(imgUrl) {
    $('.pers-ref-modal').remove();

    var overlay = document.createElement('div');
    overlay.className = 'pers-ref-modal';

    var inner = document.createElement('div');
    inner.className = 'pers-ref-modal-inner';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'pers-ref-modal-close';
    closeBtn.innerHTML = '<i class="las la-times"></i>';

    var img = document.createElement('img');
    img.src = imgUrl;
    img.alt = 'Locais de personalização';

    inner.appendChild(closeBtn);
    inner.appendChild(img);
    overlay.appendChild(inner);
    document.body.appendChild(overlay);

    setTimeout(function () {
      $(overlay).addClass('open');
    }, 10);

    function closeModal() {
      $(overlay).removeClass('open');
      setTimeout(function () {
        $(overlay).remove();
      }, 300);
    }

    $(closeBtn).on('click', closeModal);
    $(overlay).on('click', function (e) {
      if (e.target === overlay) closeModal();
    });
  }

  // =============================================
  // UTILS
  // =============================================
  function formatCurrency(value) {
    return (
      'R$ ' +
      value
        .toFixed(2)
        .replace('.', ',')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    );
  }

  function savePersonalizacao() {
    try {
      localStorage.setItem(LOCAL_PERS_KEY, JSON.stringify(personalizacao));
    } catch (e) {
      /* ignore */
    }
  }

  // =============================================
  // INICIAR
  // =============================================
  init();
})();
